import { Component } from "react";
// React-DML imports
import { Cell, Grid } from "react-mdl";

// Importing CSS
import "../styles/TermsOfService.css";

export class TOC extends Component {
  render() {
    return (
      <div>
        <Grid className="TOS-Page-Grid">
          <Cell col={12}>
            <div className="TOS-title-text">
              <h1>Terms of Service</h1>

              <p className="TOS-date">Last updated: August 6th, 2025</p>

              <p>
                These Terms of Service ("Terms") govern your access to and use
                of our website located at{" "}
                <a
                  href="https://www.rakeen.cc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.rakeen.cc
                </a>{" "}
                and the services provided by Rakeen ("Rakeen", "we", "us",
                or "our").
              </p>

              <h2>1. Purpose of the Website</h2>
              <p>
                This website is operated by Rakeen, a technology company based
                in Riyadh, Saudi Arabia. Rakeen provides digital marketing and
                CRM solutions, including advertising campaign management
                across platforms such as TikTok and Snapchat, customer
                relationship management tools, analytics and reporting, and
                ad landing pages with lead attribution.
              </p>

              <h2>2. Acceptance of Terms</h2>
              <p>
                By accessing or using our website, you agree to be bound by
                these Terms and our{" "}
                <a href="/privacy" target="_blank" rel="noopener noreferrer">
                  Privacy Policy
                </a>
                .
              </p>

              <h2>3. Intellectual Property</h2>
              <p>
                All content on this website, including text, graphics, logos,
                and software, is the property of Rakeen or its licensors and is
                protected by applicable copyright and trademark laws.
              </p>

              <h2>4. Use Restrictions</h2>
              <p>
                You agree not to misuse the site, including attempting to gain
                unauthorized access, interfering with service operations, or
                transmitting malicious code.
              </p>

              <h2>5. Disclaimer</h2>
              <p>
                All content and functionality on the site are provided "as is"
                without warranty of any kind. We do not guarantee that the site
                will be error-free or uninterrupted.
              </p>

              <h2>6. Limitation of Liability</h2>
              <p>
                In no event shall Rakeen be liable for any indirect, incidental,
                or consequential damages arising from your use of the site or
                reliance on its content.
              </p>

              <h2>7. Modifications</h2>
              <p>
                We reserve the right to update or modify these Terms at any time
                without prior notice. Updates will be effective upon posting on
                this page.
              </p>

              <h2>8. Governing Law</h2>
              <p>
                These Terms shall be governed by and construed in accordance
                with the laws of the Kingdom of Saudi Arabia.
              </p>

              <h2>9. Contact Us</h2>
              <p>
                If you have any questions about these Terms, you can contact us:
              </p>
              <ul>
                <li>
                  By email: <a href="mailto:info@rakeen.cc">info@rakeen.cc</a>
                </li>
                <li>
                  By visiting this page on our website:{" "}
                  <a
                    href="https://www.rakeen.cc/contact"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://www.rakeen.cc/contact
                  </a>
                </li>
              </ul>
            </div>
          </Cell>
        </Grid>
      </div>
    );
  }
}

export default TOC;
